import { useLessonsBlock } from '@/pages/admin/courses/studio/CourseStudio.hooks';
import CreateLessonBlockList from './CreateLessonBlockList';
import CreateLessonList from './CreateLessonList';
import CreateLessonListProps from './CreateLessonListProps';

export default function ListLessonsFactory(props: CreateLessonListProps) {
  const { lessonBlocks } = useLessonsBlock(props.slugCourseName);

  if (lessonBlocks.length) {
    return <CreateLessonBlockList {...props} />;
  }

  return <CreateLessonList {...props} />;
}
